module.exports = __webpack_public_path__ + "static/media/arrow-white.4cc230d0.svg";